import { createRouter, createWebHistory } from 'vue-router'

import Home from '../components/Home.vue'
import CreditsTable from '../components/CreditsTable.vue'
import TrialSignup from '../components/TrialSignup.vue'
import PackSelector from '../components/PackSelector.vue'

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/credits', name: 'Credits', component: CreditsTable },
  { path: '/trial', name: 'Trial', component: TrialSignup },
  { path: '/purchase', name: 'Purchase', component: PackSelector }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
